import { render, staticRenderFns } from "./QuestionEdit.vue?vue&type=template&id=8c87e624&scoped=true&"
import script from "./QuestionEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuestionEdit.vue?vue&type=style&index=0&id=8c87e624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c87e624",
  null
  
)

export default component.exports